import { FC } from "react";
import cn from "classnames";
import AvatarStack from "../AvatarStack/AvatarStack";
import { PersonalSummaryType } from "./constants";
import { buildShownNames } from "./utils";

const PersonalSummary: FC<PersonalSummaryType> = ({
  items,
  title,
  nameOverflowCount = 0,
  imgOverflowCount = 0,
  avatarSize,
  overlapRatio,
  nameJoin = " + ",
  overflowLabel,
  chipSubtitle,
  chipTitle,
  classNames,
  className,
}) => {
  const calculatedChipTitle = chipTitle?.(items);
  const shownNames = calculatedChipTitle
    ? null
    : buildShownNames(items, nameOverflowCount, nameJoin, overflowLabel);

  const subtitle = chipSubtitle?.(items);

  return (
    <div className={cn("flex flex-col gap-2", className, classNames?.root)}>
      <div className={cn(classNames?.sectionTitle)}>{title}</div>
      <div className={cn("flex flex-wrap items-center gap-2", classNames?.chipContainer)}>
        <AvatarStack
          items={items}
          imgOverflowCount={imgOverflowCount}
          className={classNames?.avatarsContainer}
          classNames={classNames}
          avatarSize={avatarSize}
          overlapRatio={overlapRatio}
        />
        <div className={cn("flex flex-col items-start gap-1", classNames?.chipInfo)}>
          <div className={cn(classNames?.chipTitle)}>{calculatedChipTitle ?? shownNames}</div>
          {subtitle && <div className={cn("text-font-subtle", classNames?.chipSubtitle)}>{subtitle}</div>}
        </div>
      </div>
    </div>
  );
};

export default PersonalSummary;
